import React from "react";
import "../styles/Quiz.css";

interface TheoryQuestionProps {
  questionNumber: number;
  totalQuestions: number;
  question: string;
  answer: string;
  onChange: (value: string) => void;
}

const TheoryQuestion: React.FC<TheoryQuestionProps> = ({
  questionNumber,
  totalQuestions,
  question,
  answer,
  onChange,
}) => {
  return (
    <div className="question-card">
      <div className="question-count">
        Question {questionNumber} of {totalQuestions}
      </div>

      <h2>{question}</h2>

      <textarea
        className="theory-textarea"
        value={answer}
        onChange={(e) => onChange(e.target.value)}
        placeholder="Write your answer here..."
      />
    </div>
  );
};

export default TheoryQuestion;
